import React, { Fragment, useEffect, useState } from "react";
//import { StatCard } from "../global/StatCard";

import {
  MonitorCog,
  Network,
  Cpu,
  Microchip,
  DatabaseZap,
  ServerCog,
  RefreshCw,
} from "lucide-react";
import { ServerCard } from "../../global/ServerCard";
import { ServiceCard } from "../../global/ServiceCard";
import { SystemCard } from "../../global/SystemCard";
import { getVPSMetrics } from "../../service/VPSMetrics";
import MetricsCard from "../../tools/MetricsCard";
import { MyModal } from "../../global/MyModal";

export function Dashboard() {
  const [cpuUsage, setCpuUsage] = useState(0);
  const [cpuUsages, setCpuUsages] = useState([]);
  const [ramUsage, setRamUsage] = useState(0);
  const [ramUsages, setRamUsages] = useState([]);
  const [diskSpace, setDiskSpace] = useState(0);
  const [diskSpaces, setDiskSpaces] = useState([]);
  const [netTraffic, setNetTraffic] = useState(0);
  const [inTraffic, setInTraffic] = useState(0);
  const [inTraffics, setInTraffics] = useState([]);
  const [outTraffics, setOutTraffics] = useState([]);
  const [outTraffic, setOutTraffic] = useState(0);


  const [seconds, setSeconds] = useState(10);
  const getMetrics = async () => {
    try {
      //
      const res = await getVPSMetrics();
      const data = res?.data;
      const cpu_usage = Object.entries(data?.cpu_usage.usage)[0][1];
      const cpu_usages = Object.entries(data?.cpu_usage.usage || [])
        .map(([timestamp, value]) => ({
          time: timestamp,
          value: value,
        }))
        .sort((a, b) => a.time - b.time);

      const ram_usage = Object.entries(data?.ram_usage.usage)[0][1];
      const ram_usages = Object.entries(data?.ram_usage.usage || [])
        .map(([timestamp, value]) => ({
          time: timestamp,
          value: value,
        }))
        .sort((a, b) => a.time - b.time);

      const disk_space = Object.entries(data?.disk_space.usage)[0][1];
      const disk_spaces = Object.entries(data?.disk_space.usage || [])
        .map(([timestamp, value]) => ({
          time: timestamp,
          value: value,
        }))
        .sort((a, b) => a.time - b.time);

      const incoming_traffic = Object.entries(
        data?.incoming_traffic.usage,
      )[0][1];
      const in_traffics = Object.entries(data?.incoming_traffic.usage || [])
        .map(([timestamp, value]) => ({
          time: timestamp,
          value: value,
        }))
        .sort((a, b) => a.time - b.time);
      const outgoing_traffic = Object.entries(
        data?.outgoing_traffic.usage,
      )[0][1];
      const out_traffics = Object.entries(data?.outgoing_traffic.usage || [])
        .map(([timestamp, value]) => ({
          time: timestamp,
          value: value,
        }))
        .sort((a, b) => a.time - b.time);
      const net_traffic = incoming_traffic + outgoing_traffic;

      console.log("ram usage", formatBytes(ram_usage));
      console.log("total Ram", "8GB");
      console.log("cpu usage", cpu_usage);
      console.log("disk space", disk_space);
      console.log("incoming traffic", incoming_traffic);
      console.log("outgoing traffic", outgoing_traffic);

      setCpuUsage(cpu_usage);
      setCpuUsages(cpu_usages);
      setRamUsage(ram_usage);
      setRamUsages(ram_usages);
      setDiskSpace(disk_space);
      setDiskSpaces(disk_spaces);
      setNetTraffic(net_traffic);
      setInTraffics(in_traffics);
      setInTraffic(incoming_traffic);
      setOutTraffic(outgoing_traffic);
      setOutTraffics(out_traffics);
    } catch (err) {
      console.error("failed to fetch data :", err);
    }
  };

  useEffect(() => {
    getMetrics();
    const interval = setInterval(() => {
      setSeconds((prev) => {
        if (prev === 1) {
          getMetrics(); // refresh API
          return 10; // reset timer
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  return (
  
      <div className="space-y-4">
        <div className="flex justify-end items-center">
          <button
            onClick={() => {
              setSeconds(10); // reset timer
              getMetrics();
            }}
            className="text-xs px-2 py-2 bg-gray-800 text-white rounded-lg items-center justify-center flex space-x-1 hover:bg-gray-700 transition-colors duration-300"
          >
            <RefreshCw size={16} className=" inline-block mr-1" />
            <span>Refresh in {seconds}s</span>
          </button>
        </div>
        {/* Server Info */}
        <ServerCard />
        {/* d */}
        {/* System matrics--------------------------------------------- */}
        <div className="flex items-center justify-start space-x-2">
          <MonitorCog className="w-4 h-4 text-black dark:text-slate-200" />
          <h2 className="text-sm font-bold text-black dark:text-slate-200">
            System Matrics
          </h2>
        </div>

        {/* stats grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {/* CPU Usage */}
          <MetricsCard
            graphData={cpuUsages}
            title={"CPU usage"}
            value={`${cpuUsage}%`}
            unit={"%"}
          />
          {/* Ram Usage */}
          <MetricsCard
            graphData={ramUsages}
            title={"Memory usage"}
            value={`${Number((ramUsage / 8000000000) * 100).toFixed(1) + "%"}`}
            unit={"."}
          />
          {/* Disk Usage */}
          <MetricsCard
            graphData={diskSpaces}
            title={"Disk usage"}
            value={formatBytes(diskSpace)}
            unit={""}
            totalValue={100 + " GB"}
            percentage={Number((diskSpace / 100000000000) * 100).toFixed(1)}
          />

          {/* Incoming Traffic */}
          <MetricsCard
            graphData={inTraffics}
            title={"Incoming traffic"}
            value={formatBytes(inTraffic)}
            unit={""}
          />
          {/* Outgoing Traffic */}
          <MetricsCard
            graphData={outTraffics}
            title={"Outgoing traffic"}
            value={formatBytes(outTraffic)}
            unit={""}
          />
          {/* Bandwidth */}
          <MetricsCard
            graphData={outTraffics}
            title={"Bandwidth"}
            value={formatBytes(netTraffic)}
            totalValue={8 + " TB"}
            percentage={Number((netTraffic / 8192000000000000) * 100).toFixed(
              1,
            )}
            unit={""}
          />
          {/* <SystemCard
          title={"CPU Usage"}
          mIcon={Cpu}
          value={cpuUsage}
          isPer={true}
          progressPercentage={cpuUsage}
        /> */}
          {/* 
        <SystemCard
          title={"Memory Usage"}
          mIcon={Microchip}
          value={formatBytes(ramUsage)}
          totalValue={8 + "GB"}
          isPer={false}
          progressPercentage={(ramUsage / 8000000000) * 100}
        /> */}

          {/* <SystemCard
          title={"Storage Usage"}
          mIcon={DatabaseZap}
          value={formatBytes(diskSpace)}
          totalValue={100 + "GB"}
          isPer={false}
          progressPercentage={(diskSpace / 100000000000) * 100}
        /> */}

          {/* <SystemCard
          title={"Natwork I/O"}
          mIcon={Network}
          value={formatBytes(netTraffic)}
          totalValue={"s"}
          isPer={false}
          progressPercentage={(netTraffic / 8192000000000000) * 100}
        /> */}
        </div>
        {/* Service Status --------------------------------------------- */}
        {/* <div className="flex items-center justify-start space-x-2">
        <ServerCog className="w-4 h-4 text-black dark:text-slate-200" />
        <h2 className="text-sm font-bold text-black dark:text-slate-200">
          Services Status
        </h2>
      </div> */}
        {/* <div className="grid grid-cols-2 md:grid-cols-2 xl:grid-cols-2 gap-2">
        <ServiceCard
          title={"MariaDB"}
          subtitle={
            "vmysql Ver 15.1 Distrib 10.6.22-MariaDB, for debian-linux-gnu(x86_64) using EditLine wrapper"
          }
          port={":3306"}
          uptime={"280"}
          memory={"0.2MB"}
          responseTime={"23.0ms"}
          status={"Healthy"}
          image={
            "https://mariadb.com/wp-content/uploads/2019/11/mariadb-logo-vert_blue-transparent.png"
          }
        />
        <ServiceCard
          title={"Nginx"}
          subtitle={"vnginx version: nginx/1.18.0 (Ubuntu)"}
          port={":80"}
          uptime={"280m"}
          memory={"0.0MB"}
          responseTime={"1.2ms"}
          status={"Healthy"}
          image={"https://iconape.com/wp-content/png_logo_vector/nginx.png"}
        />
        <ServiceCard
          title={"Redis"}
          subtitle={"vnginx version: nginx/1.18.0 (Ubuntu)"}
          port={":80"}
          uptime={"280m"}
          memory={"0.0MB"}
          responseTime={"1.2ms"}
          status={"Healthy"}
          image={"https://snapdb.app/img/db/redis.png"}
        />

        <ServiceCard
          title={"Backend"}
          subtitle={"1.0.0v"}
          port={":80"}
          uptime={"280m"}
          memory={"0.0MB"}
          responseTime={"1.2ms"}
          status={"Healthy"}
          image={
            "https://w7.pngwing.com/pngs/414/85/png-transparent-nodejs-javascript-runtime-backend-node-js-logo-3d-icon.png"
          }
        />
      </div> */}
      </div>
     
  
  );
}
function formatBytes(bytes) {
  if (bytes < 1024) {
    return bytes + " B";
  } else if (bytes < 1024 ** 2) {
    return (bytes / 1024).toFixed(0) + " KB";
  } else if (bytes < 1024 ** 3) {
    return (bytes / 1024 ** 2).toFixed(2) + " MB";
  } else if (bytes < 1024 ** 4) {
    return (bytes / 1024 ** 3).toFixed(0) + " GB"; // 👈 1 digit
  } else {
    return (bytes / 1024 ** 4).toFixed(2) + " TB"; // 👈 added TB
  }
}

function formatGB(bytes) {
  return (bytes / 1024 ** 4).toFixed(5) + " TB"; // 👈 1 digit
}
